import { BillSchema } from '@eigtech/invoicing-types'
import { JobBillDetail } from '@/components/Domains/Jobs'
import { withRequiredPermissions } from '@/lib/permissions'
import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'

const Schema = z.object({
  billId: BillSchema.shape.id,
})

export const Route = createFileRoute('/_auth/jobs/$jobId/_layout/billing_/bill/$billId')({
  component: () => <Page />,
  parseParams: Schema.parse,
})

const Page = withRequiredPermissions(JobBillDetail, {
  requiredPermissions: [{ action: 'read', subject: 'bill' }],
})
